import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { navLinks } from '../constants';

const Navbar = ({ navOpen, setNavOpen, activeSection, handleScrollTo, scrollY }) => {
    return (
        <nav
            className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${scrollY > 50 ? 'bg-black/50 backdrop-blur-xl border-b border-white/5 py-4' : 'bg-transparent py-8'
                }`}
        >
            <div className="container flex justify-between items-center">
                <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5 }}
                    className="text-2xl font-bold font-outfit tracking-tighter text-white cursor-pointer"
                    onClick={() => handleScrollTo('#hero')}
                >
                    TA<span className="text-primary-purple">.</span>
                </motion.div>

                {/* Desktop Menu */}
                <div className="hidden md:flex gap-10">
                    {navLinks.map((link, index) => (
                        <motion.a
                            key={link.name}
                            href={link.href}
                            initial={{ opacity: 0, y: -10 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.1, duration: 0.5 }}
                            onClick={(e) => {
                                e.preventDefault();
                                handleScrollTo(link.href);
                            }}
                            className={`text-sm font-medium transition-all duration-300 relative hover:text-white ${activeSection === link.href.substring(1)
                                    ? 'text-white'
                                    : 'text-gray-400'
                                }`}
                        >
                            {link.name}
                            {activeSection === link.href.substring(1) && (
                                <motion.span
                                    layoutId="activeSection"
                                    className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-1 h-1 bg-primary-purple rounded-full"
                                />
                            )}
                        </motion.a>
                    ))}
                </div>

                {/* Mobile Menu Toggle */}
                <div className="md:hidden text-white cursor-pointer" onClick={() => setNavOpen(!navOpen)}>
                    {navOpen ? <X size={24} /> : <Menu size={24} />}
                </div>
            </div>

            {/* Mobile Menu */}
            {navOpen && (
                <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: '100vh' }}
                    exit={{ opacity: 0, height: 0 }}
                    className="md:hidden fixed inset-0 bg-black z-40 flex items-center justify-center"
                >
                    <div className="flex flex-col gap-8 text-center">
                        {navLinks.map((link) => (
                            <a
                                key={link.name}
                                href={link.href}
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleScrollTo(link.href);
                                }}
                                className={`text-3xl font-bold font-outfit transition-colors ${activeSection === link.href.substring(1)
                                        ? 'text-white'
                                        : 'text-gray-500'
                                    }`}
                            >
                                {link.name}
                            </a>
                        ))}
                    </div>
                </motion.div>
            )}
        </nav>
    );
};

export default Navbar;
